import { css } from 'styled-components';
import { breakpoint } from '../mixins/breakpoints';
import { fontFamilyBlack } from '../variables/typography';

export const grid = css`
  display: grid;

  // Generate gap different breakpoints
  ${(p) =>
    Object.keys(p.theme.grid.gridRowGutter).map(
      (key) => css`
        ${breakpoint(key)} {
          gap: ${(p) => p.theme.grid.gridRowGutter[key]};
        }
      `
    )}
`;

const generateGridTemplateColumns = (
  cells: number,
  fractions: string = '1fr'
) => {
  switch (cells) {
    case 1:
    case undefined:
      return css`
        grid-template-columns: ${fractions};
      `;
    default:
      return css`
        grid-template-columns: repeat(${cells}, ${fractions});
      `;
  }
};

export const cells = (cells: number, fraction?: string) => css`
  ${generateGridTemplateColumns(cells, fraction)}
`;

export const span = (span: number) => css`
  grid-column: span ${span};
`;

export const section = css`
  max-width: ${(p) => p.theme.grid.rowMaxWidth};
  margin-left: auto;
  margin-right: auto;

  // Generate section paddings for different breakpoints
  ${(p) =>
    Object.keys(p.theme.grid.gridRowGutter).map(
      (key) => css`
        ${breakpoint(key)} {
          padding-left: ${(p) => p.theme.grid.gridRowGutter[key]};
          padding-right: ${(p) => p.theme.grid.gridRowGutter[key]};
        }
      `
    )}
`;

export default css`
  .section {
    ${section}

    &--fullwidth {
      max-width: none;
    }
    &--category {
      padding-left: 0;
      padding-right: 0;
      ${breakpoint('large')} {
        padding-left: 3.2rem;
        padding-right: 3.2rem;
      }
      ${breakpoint('xlarge')} {
        padding-left: 4.8rem;
        padding-right: 4.8rem;
      }
    }
    &--fullwidth-mobile {
      padding-left: 0;
      padding-right: 0;

      .section_title {
        padding: 0 1.6rem;
        ${fontFamilyBlack}
      }

      ${breakpoint('medium')} {
        ${(p) =>
          Object.keys(p.theme.grid.gridRowGutter).map(
            (key) => css`
              ${breakpoint(key)} {
                padding-left: ${(p) => p.theme.grid.gridRowGutter[key]};
                padding-right: ${(p) => p.theme.grid.gridRowGutter[key]};
              }
            `
          )}

        .section_title {
          padding: 0;
          ${fontFamilyBlack}
        }
      }
    }
  }
  .grid {
    ${grid}
  }

  .grid-auto-rows {
    grid-auto-rows: 1fr;
  }
`;
